import { useQuery } from 'react-query';

import { BasicEntity, getFollowedEntities } from '@utils/backend-api/entities';

export const FOLLOWED_ENTITIES_KEY = 'FollowedEntities';
export const generateFollowedEntitiesKey = (identityId: number | string) => [
  FOLLOWED_ENTITIES_KEY,
  identityId,
];

export default function useFollowedEntities(identityId: number | string) {
  const { data: followedEntities, isLoading: areFollowedIdentitiesLoading } = useQuery<
    BasicEntity[]
  >(generateFollowedEntitiesKey(identityId), () => getFollowedEntities(identityId), {
    enabled: !!identityId,
  });

  return { followedEntities, areFollowedIdentitiesLoading };
}
